<div class="container">
  <div class="scrollable-content">
    <simple-header title="Panel de control" [back]="true" icon="close"></simple-header>
    <mat-action-list>
      <button mat-list-item (click)="gotoListUsers()" [allowAction]="['users.list']">
        <mat-icon matListItemIcon>account_circle</mat-icon> <span>Usuarios</span>
      </button>
      <button mat-list-item [routerLink]="['/app/list-asoc-material']" [allowAction]="['materials.associate']">
        <mat-icon matListItemIcon>wb_incandescent</mat-icon> <span>Material por luminaria</span>
      </button>
      <button mat-list-item [routerLink]="['/app/material']" [allowAction]="['materials.list']">
        <mat-icon matListItemIcon>extension</mat-icon> <span>Material</span>
      </button>
      <button mat-list-item [routerLink]="['/app/list-projects']" [allowAction]="['projects.list']">
        <mat-icon matListItemIcon>folder</mat-icon> <span>Proyectos</span>
      </button>
      <button mat-list-item [routerLink]="['/app/list-stores']" [allowAction]="['store.list']">
        <mat-icon matListItemIcon>list</mat-icon> <span>Almacen</span>
      </button>
    </mat-action-list>
  </div>
</div>
